export const defaultThemeConfig = {
  version: "1.0",
  global: {
    color: "#fef9e7", // Warm cream/white
    background: "#166534", // Medium forest green
    fontSize: "1rem",
    fontWeight: "400",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
  },
  header: {
    color: "#fde047", // Bright yellow
    background: "#14532d", // Dark forest green
    fontSize: "2rem",
    fontWeight: "700",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
  },
  runningMessages: {
    regular: {
      color: "#ffffff", // White
      background: "#15803d", // Bright green
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    },
    important: {
      color: "#14532d", // Dark forest green
      background: "#fde047", // Bright yellow
      fontSize: "1.25rem",
      fontWeight: "700",
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    },
  },
  events: {
    container: {
      color: "#14532d", // Dark forest green
      background: "#fef9e7", // Warm cream - stands out!
    },
    title: {
      color: "#14532d", // Dark forest green
      fontSize: "1.25rem",
      fontWeight: "700",
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    },
    teams: {
      color: "#166534", // Medium green
      fontSize: "1rem",
      fontWeight: "600",
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    },
    badges: {
      timeRange: {
        color: "#14532d", // Dark forest green
        background: "#fde047", // Bright yellow - stands out!
        fontSize: "1.25rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      room: {
        color: "#ffffff", // White
        background: "#15803d", // Bright green
        fontSize: "1rem",
        fontWeight: "600",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      location: {
        color: "#14532d", // Dark forest green
        background: "#fef08a", // Light yellow
        fontSize: "1rem",
        fontWeight: "600",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      recurrence: {
        color: "#ffffff", // White
        background: "#166534", // Medium green
        fontSize: "1rem",
        fontWeight: "600",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
    states: {
      future: {
        color: "#14532d", // Dark forest green
        background: "#e5e7eb", // Light gray
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      upcoming: {
        color: "#14532d", // Dark forest green
        background: "#fde047", // Bright yellow - stands out!
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      ongoing: {
        color: "#ffffff", // White
        background: "#16a34a", // Bright lime green - stands out!
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      ending: {
        color: "#ffffff", // White
        background: "#ea580c", // Bright orange (warning) - stands out!
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      ended: {
        color: "#ffffff", // White
        background: "#6b7280", // Gray
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      canceled: {
        color: "#ffffff", // White
        background: "#991b1b", // Dark red - stands out!
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
  },
  contentBlocks: {
    clock: {
      container: {
        background: "transparent",
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      time: {
        color: "#fde047", // Bright yellow
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      weekday: {
        color: "#ffffff", // White
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      month: {
        color: "#ffffff", // White
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      year: {
        color: "#ffffff", // White
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
    calendar: {
      container: {
        color: "#ffffff", // White
        background: "transparent",
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      month: {
        color: "#fde047", // Bright yellow
        background: "transparent",
        fontSize: "1.5rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      weekdays: {
        color: "#fef08a", // Light yellow
        background: "transparent",
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      weeknumbers: {
        color: "#d9f99d", // Light lime
        background: "transparent",
        fontSize: "1rem",
        fontWeight: "600",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      day: {
        color: "#ffffff", // White
        background: "transparent",
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      currentDay: {
        color: "#14532d", // Dark forest green
        background: "#fde047", // Bright yellow
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
    countdown: {
      container: {
        color: "#ffffff", // White
        background: "transparent",
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      title: {
        color: "#fde047", // Bright yellow
        fontSize: "2rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      time: {
        color: "#fde047", // Bright yellow
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      almostUp: {
        color: "#fb923c", // Bright orange (warning)
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      onDone: {
        color: "#86efac", // Bright lime green
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
    countup: {
      container: {
        color: "#ffffff", // White
        background: "transparent",
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      header: {
        color: "#fde047", // Bright yellow
        fontSize: "2rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      value: {
        color: "#fde047", // Bright yellow
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      label: {
        color: "#fde047", // Bright yellow
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
      footer: {
        color: "#fb923c", // Bright orange (warning)
        fontSize: "3rem",
        fontWeight: "700",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      },
    },
    message: {
      container: {
        color: "inherit", // White
        background: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        fontFamily: "inherit",
      },
    },
  },
};
